import { useLanguage } from '../utils/LanguageContext';
import { getAddressItem } from './AddressView';
import translations from './ComponentsTranslations.lang.json';

import { ItemView } from './common/CommonComponents';
import { formatName } from './common/util';

const EmployerView = ({ employer }) => {
  const { lang } = useLanguage(translations);

  const items = [
    {
      field: 'employerName',
      value: employer.employerName,
    },
    {
      field: 'payrollProvider',
      value: employer.payrollProvider,
    },
    {
      field: 'employerContactName',
      value: employer?.employerContact?.name && formatName(employer.employerContact.name),
    },
    {
      field: 'employerContactTitle',
      value: employer?.employerContact?.title,
    },
    {
      field: 'email',
      value: employer?.employerContact?.email,
    },
    {
      field: 'phoneNumber',
      value: employer?.employerContact?.phoneNumber,
    },
    getAddressItem(employer?.employerAddress, lang),
  ];

  return <ItemView items={items} />;
};

export default EmployerView;
